export const formatCurrency = (amount) => {
  // Round to whole dollars and format with commas for thousands
  return `$${Math.round(amount).toLocaleString('en-US')}`;
};

// Alternative version that keeps cents if you need it later
export const formatCurrencyWithCents = (amount) => {
  return `$${parseFloat(amount).toLocaleString('en-US', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2
  })}`;
}; 